import React, { FunctionComponent } from "react";
import { ComponentProps } from "../components/component-props";
import { Demo } from "../components/demo";

import "./menu-demo.scss";

// Menu

const menuCode = `const MenuDemo = () => {
    const anchor = React.useRef(null);
    const [isOpen, setIsOpen] = React.useState(false);
    return (
        <MenuAnchor>
            <TextButton contained onClick={() => setIsOpen(!isOpen)}>
                Toggle Menu
            </TextButton>

            <Menu
                open={isOpen}
                onClose={() => setIsOpen(false)}
                anchorCorner="bottomLeft"
            >
                <List>
                    <ListItem>
                        <ListItemText>My Settings</ListItemText>
                    </ListItem>
                    <ListItem>
                        <ListItemText>Log Out</ListItemText>
                    </ListItem>
                </List>
            </Menu>
        </MenuAnchor>
    );
};

render(<MenuDemo />);`;

const menuDemo = {
    code: menuCode,
    noInline: true
};

export const MenuDemo: FunctionComponent = () => {
    return (
        <Demo demo={menuDemo}>
            <ComponentProps componentName="Menu" />
        </Demo>
    );
};


// Exposed Dropdown Menu

const exposedDropdownMenuDemo = {
    noInline: true,
    code:
`const ExposedDropdownMenuDemo = () => {
    const [selectedValue, setSelectValue] = React.useState("");
    const options = [
        { label: "Option 1", value: "1" },
        { label: "Option 2", value: "2" },
        { label: "Option 3", value: "3" }
    ];

    return (
        <ExposedDropdownMenu
            label="Select an option"
            options={options}
            value={selectedValue}
            onValueChange={value => {
                setSelectValue(value);
            }}
        />
    );
};

render(<ExposedDropdownMenuDemo />);`
};

export const ExposedDropdownMenuDemo: FunctionComponent = () => {
    return (
        <Demo demo={exposedDropdownMenuDemo}>
            <ComponentProps componentName="ExposedDropdownMenu" />
        </Demo>
    );
};


// Editable Dropdown Menu

const editableDropdownMenuDemo = {
    noInline: true,
    code:
`const EditableDropdownMenuDemo = () => {
    const [value, setValue] = React.useState("");

    const options = [
        { label: "Option 1", value: "1" },
        { label: "Option 2", value: "2" },
        { label: "Option 3", value: "3" }
    ];

    return (
        <EditableDropdownMenu
            label="Options"
            options={options}
            noResultsText="No results found"
            onValueChange={setValue}
            value={value}
        />
    );
};


render(<EditableDropdownMenuDemo />);`
};

export const EditableDropdownMenuDemo: FunctionComponent = () => {
    return (
        <Demo demo={editableDropdownMenuDemo}>
            <ComponentProps componentName="EditableDropdownMenu" />
        </Demo>
    );
};
